import { ChalkboardTeacher, MagnifyingGlass, Buildings, Handshake } from "@phosphor-icons/react";
import { SectionLabel } from "@/components/shared/SectionLabel";
import { RevealText } from "@/components/shared/RevealText";
import { ServiceCard } from "@/components/shared/ServiceCard";
import { SERVICES_SHORT } from "@/data/siteData";

const ICONS = { ChalkboardTeacher, MagnifyingGlass, Buildings, Handshake };

export const WhatWeDo = () => (
  <section className="py-24 px-6 bg-cream">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-14">
        <SectionLabel>What We Do</SectionLabel>
        <RevealText
          as="h2"
          text="The Right Teachers. The Right Fit."
          className="font-heading text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-tight"
        />
        <p className="mt-5 text-slate text-base leading-relaxed">
          Mithra Jobs helps schools identify teaching professionals according to their requirements, from initial
          search through to final selection.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES_SHORT.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <ServiceCard
              key={s.title}
              index={i}
              title={s.title}
              description={s.description}
              icon={<Icon size={26} weight="duotone" className="text-navy" />}
            />
          );
        })}
      </div>
    </div>
  </section>
);
